var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoyenneTempsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7011_8084)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "#FAF8F6"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7011_8084)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    transform: "translate(2.5 2.5)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4984 11.8984C16.3909 11.8984 15.3082 12.2269 14.3872 12.8422C13.4663 13.4575 12.7486 14.3321 12.3247 15.3554C11.9009 16.3787 11.79 17.5046 12.006 18.5909C12.2221 19.6772 12.7555 20.6751 13.5386 21.4582C14.3218 22.2414 15.3196 22.7748 16.4059 22.9908C17.4922 23.2069 18.6182 23.096 19.6415 22.6722C20.6647 22.2483 21.5393 21.5305 22.1547 20.6096C22.77 19.6887 23.0984 18.606 23.0984 17.4984C23.0968 16.0137 22.5063 14.5903 21.4564 13.5404C20.4066 12.4906 18.9832 11.9001 17.4984 11.8984ZM20.0478 19.4291C19.9981 19.492 19.935 19.5429 19.8629 19.578C19.7909 19.6131 19.7119 19.6314 19.6318 19.6318C19.5112 19.6327 19.3941 19.5912 19.301 19.5144L17.1677 17.9144C17.1049 17.8647 17.0541 17.8015 17.019 17.7295C16.9839 17.6575 16.9655 17.5785 16.9651 17.4984V13.7651C16.9651 13.6237 17.0213 13.488 17.1213 13.388C17.2213 13.288 17.357 13.2318 17.4984 13.2318C17.6399 13.2318 17.7755 13.288 17.8756 13.388C17.9756 13.488 18.0318 13.6237 18.0318 13.7651V17.2424L19.9625 18.6824C20.018 18.7252 20.0644 18.7787 20.0988 18.8397C20.1333 18.9008 20.1551 18.9681 20.1631 19.0377C20.171 19.1074 20.1649 19.1779 20.1451 19.2451C20.1253 19.3123 20.0922 19.3749 20.0478 19.4291Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 9.5C15.9178 9.5 14.371 9.96919 13.0554 10.8482C11.7398 11.7273 10.7145 12.9767 10.109 14.4385C9.50347 15.9003 9.34504 17.5089 9.65372 19.0607C9.9624 20.6126 10.7243 22.038 11.8431 23.1569C12.962 24.2757 14.3874 25.0376 15.9393 25.3463C17.4911 25.655 19.0997 25.4965 20.5615 24.891C22.0233 24.2855 23.2727 23.2602 24.1518 21.9446C25.0308 20.629 25.5 19.0822 25.5 17.5C25.4974 15.3791 24.6537 13.3457 23.154 11.846C21.6543 10.3463 19.6209 9.50258 17.5 9.5ZM17.5 24.2022C16.1744 24.2022 14.8786 23.8091 13.7765 23.0727C12.6743 22.3362 11.8152 21.2895 11.308 20.0648C10.8007 18.8402 10.668 17.4926 10.9266 16.1925C11.1852 14.8924 11.8235 13.6981 12.7608 12.7608C13.6981 11.8235 14.8924 11.1852 16.1925 10.9266C17.4926 10.668 18.8402 10.8007 20.0648 11.308C21.2895 11.8152 22.3362 12.6743 23.0727 13.7764C23.8091 14.8786 24.2022 16.1744 24.2022 17.5C24.2005 19.277 23.4938 20.9807 22.2373 22.2373C20.9808 23.4938 19.277 24.2005 17.5 24.2022Z",
    fill: "black"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 34.5,
    height: 34.5,
    stroke: "#E6E6E7",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7011_8084",
    x: 0.5,
    y: 2.5,
    width: 34,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_7011_8084"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.584314 0 0 0 0 0.627451 0 0 0 0 0.698039 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7011_8084"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7011_8084",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7011_8084"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoyenneTempsIcon);
export default __webpack_public_path__ + "static/media/moyenneTempsIcon.5c7c275c6e59e059415deb57f6a3a184.svg";
export { ForwardRef as ReactComponent };